import { graphql } from 'src/graphql';

export const ExchangeImpersonationToken = graphql(`
  mutation ExchangeImpersonationToken($teamId: ID!) {
    exchangeImpersonationToken(teamId: $teamId) {
      token
      url
    }
  }
`);
